import { isValidRuc } from 'src/functions/identificationMethods';

export const formatErrorText =
  'Su número de RUC no está en el formato correcto';

/**
 * Although all of these methods share a very similar code structure and can
 * easily be only 1 abstracted function, they need to be separated in order
 * to accomodate for future tailored error messages for each scenario
 */

/**
 * Error validation pipeline:
 * Check for correct format (three sections of digits separated by dashes)
 *
 * Note that the errors will also be triggered in this order
 */
export function validateRuc(ruc: string, idType: string): string {
  if (idType !== 'J') {
    return '';
  }

  return isValidRuc(ruc) ? '' : formatErrorText;
}
